import { z } from "zod";
import { fileSchema } from "./files.schema";

export const profilePictureSchema = z.object({
  picture: fileSchema.nullable(),
});

export const defaultProfilePictureValues = {
  picture: null,
};

export type ProfilePictureForm = z.infer<typeof profilePictureSchema>;
